import ProductDetails from "@/features/products/components/product-details";
import { appDetailTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/products/$plu")({
  head: () => appDetailTitleHead("products"),
  component: ProductDetailPage
});

function ProductDetailPage() {
  return (
    <div className="w-full">
      <ProductDetails />
    </div>
  );
}
